module.exports = __webpack_public_path__ + "img/4f1.8d15b069.jpg";